import { Component } from '@angular/core';

/**
 * @title Basic use of `<table mat-table>`
 */

@Component({
  selector: 'app-configuration-management',
  templateUrl: './configuration.management.component.html'
})
export class ConfigurationManagementComponent {
  
}